module.exports = __webpack_public_path__ + "img/people-roof-solid.551854b1.svg";